
<template>
    <div class='content'>
        <div class="container">
            <div v-html="dataList"></div>
            <!-- {{ }} -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataList: ""
        }
    },
    mounted() {
        this.getfollowList();
    },
    methods: {
        // tianyue.com/api/index/getUserAgreeAndPrivacyPolicy
        async getfollowList() {
            try {
                // 1 用户协议  2 隐私政策
                const res = await this.$get('index/getUserAgreeAndPrivacyPolicy')
                if (this.$route.query.type == 1) {
                    this.dataList = res.data.user_aggree
                } else {
                    this.dataList = res.data.privacy_policy
                }
                // console.warn(res.data, "res")
            } catch (error) { }
        },
    },
}
</script>

<style lang='scss' scoped>
.content {
    min-height: 100%;
    background: #fff;

    .container {
        margin-top: 50px;
        // height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>